import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Microservices } from 'app/core/constants/pol.enums';
import { CommunicationPreferencesPayload, MyProfile } from './profile.model';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private http = inject(HttpClient);

  public profile = new BehaviorSubject<MyProfile>(null!);

  public getMyProfile(): Observable<MyProfile> {
    const url = `${Microservices.ProviderOnline}/MyProfile`;
    return this.http.get<MyProfile>(url).pipe(
      map(res => {
        res?.noticeCommunicationPreferences?.items?.sort((a, b) => {
          const aa = `${a.lastName.toLowerCase()} ${a.firstName.toLowerCase()}`;
          const bb = `${b.lastName.toLowerCase()} ${b.firstName.toLowerCase()}`;

          return aa.localeCompare(bb);
        });

        res?.officeCommunicationPreferences?.items?.sort((a, b) => {
          const aa = `${a.lastName.toLowerCase()} ${a.firstName.toLowerCase()}`;
          const bb = `${b.lastName.toLowerCase()} ${b.firstName.toLowerCase()}`;

          return aa.localeCompare(bb);
        });

        // flatten the oaaSecurityGroups array to be used in the dropdown
        res.processedSecurityGroups = res?.oaaSecurityGroups?.flatMap(i => {
          return i.taxIds?.map(j => {
            j.id = i.id;
            return j;
          });
        })
          ?.sort((a, b) => a.name.localeCompare(b.name))
          ?.flatMap(i => `${i.id}/${i.name}/${i.taxId}`);

        return res;
      }),
      tap(res => { this.profile.next(res); })
    );
  }

  public setCommunicationPreferences(payload: CommunicationPreferencesPayload): Observable<void> {
    const url = `${Microservices.ProviderOnline}/CommunicationPreferences/IsEnabled`;

    return this.http.put<void>(url, payload);
  }
}
